import { randomHex } from '@authe/fe-commons/ids';
import { EventCriticality, criticalityFromName, EVENT_CRITICALITY_ORDER, criticalityLabel } from '@authe/fe-commons/events';
import * as triggers_star from '@authe/fe-commons/triggers';
import { anyCondition, triggerActionToRecord, notifyAction, emptyTriggerRule, parseTriggerAction, and, evaluateRule, previewRule, flattenCondition, valueText, evaluatePredicate, TRIGGER_OPERATOR_LABELS, triggerFieldLabel } from '@authe/fe-commons/triggers';
import { unwrapData, unwrapResponse } from '@authe/fe-commons/api';
import * as React3 from 'react';
import { createLogger } from '@authe/fe-commons/logging';
import { Card, CardHeader, CardTitle, CardContent, Field, Input, Select, FormControl, SelectTrigger, SelectValue, SelectContent, SelectItem, Switch, Button, ErrorState, Skeleton, EmptyState, Badge, AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction, cn, useFlatCondition, Tabs, TabsList, TabsTrigger, TabsContent, ConditionRows, Checkbox, JsonEditor, useDebounced, HashDisplay, ResourceTable, notifySuccess, notifyError, DataTableColumnHeader, CriticalityBadge, ChainAvatar } from '@authe/ui-core';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { chainDisplayName } from '@authe/fe-commons/chains';
import { formatTimestamp, formatRelativeTime } from '@authe/fe-commons/time';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ALERTS_HISTORY_PAGE_SIZE: () => ALERTS_HISTORY_PAGE_SIZE,
  ALERTS_PACKAGE: () => ALERTS_PACKAGE,
  ALERTS_PREVIEW_DEBOUNCE_MS: () => ALERTS_PREVIEW_DEBOUNCE_MS,
  ALERTS_PREVIEW_LIMIT: () => ALERTS_PREVIEW_LIMIT,
  ALERTS_RULE_EDITOR_HEIGHT: () => ALERTS_RULE_EDITOR_HEIGHT,
  ALERT_AUTHORABLE_CHANNELS: () => ALERT_AUTHORABLE_CHANNELS,
  ALERT_CHANNELS: () => ALERT_CHANNELS,
  ALERT_CHANNEL_LABELS: () => ALERT_CHANNEL_LABELS,
  AlertHistoryTable: () => AlertHistoryTable,
  DestinationEditor: () => DestinationEditor,
  DestinationList: () => DestinationList,
  NoiseControls: () => NoiseControls,
  RulePreview: () => RulePreview,
  SAMPLE_ENVELOPES: () => SAMPLE_ENVELOPES,
  SEVERITY_TO_WIRE: () => SEVERITY_TO_WIRE,
  TriggerRuleEditor: () => TriggerRuleEditor,
  alertAcknowledgedAtMs: () => alertAcknowledgedAtMs,
  alertAcknowledgedBy: () => alertAcknowledgedBy,
  alertCriticality: () => alertCriticality,
  alertDelivery: () => alertDelivery,
  alertDeliveryOutcome: () => alertDeliveryOutcome,
  alertDispatchedTo: () => alertDispatchedTo,
  alertExpiresAtMs: () => alertExpiresAtMs,
  alertGroupId: () => alertGroupId,
  alertRuleFromTriggerRule: () => alertRuleFromTriggerRule,
  alertRuleToTriggerRule: () => alertRuleToTriggerRule,
  alertSupersededAtMs: () => alertSupersededAtMs,
  alertSupersededBy: () => alertSupersededBy,
  alertTimestampMs: () => alertTimestampMs,
  alertTxHash: () => alertTxHash,
  constrainAlertRule: () => constrainAlertRule,
  createApiAlertsSource: () => createApiAlertsSource,
  createInMemoryAlertsSource: () => createInMemoryAlertsSource,
  defaultConfigFor: () => defaultConfigFor,
  destinationTarget: () => destinationTarget,
  emptyAlertRule: () => emptyAlertRule,
  emptyCopy: () => emptyCopy,
  emptyDestination: () => emptyDestination,
  evaluateAlertRule: () => evaluateAlertRule,
  isAlertAcknowledged: () => isAlertAcknowledged,
  isAlertSuperseded: () => isAlertSuperseded,
  newId: () => newId,
  previewAlertRule: () => previewAlertRule,
  severityToWire: () => severityToWire,
  useAlertDestinations: () => useAlertDestinations,
  useAlertHistory: () => useAlertHistory,
  useAlertRules: () => useAlertRules
});
var ALERTS_PACKAGE = "alerts";
var ALERTS_HISTORY_PAGE_SIZE = 25;
var ALERTS_RULE_EDITOR_HEIGHT = 320;
var ALERTS_PREVIEW_LIMIT = 50;
var ALERTS_PREVIEW_DEBOUNCE_MS = 300;
function newId(prefix) {
  return `${prefix}_${randomHex(12)}`;
}

// src/model/index.ts
var model_exports = {};
__export(model_exports, {
  ALERT_AUTHORABLE_CHANNELS: () => ALERT_AUTHORABLE_CHANNELS,
  ALERT_CHANNELS: () => ALERT_CHANNELS,
  ALERT_CHANNEL_LABELS: () => ALERT_CHANNEL_LABELS,
  SEVERITY_TO_WIRE: () => SEVERITY_TO_WIRE,
  alertAcknowledgedAtMs: () => alertAcknowledgedAtMs,
  alertAcknowledgedBy: () => alertAcknowledgedBy,
  alertCriticality: () => alertCriticality,
  alertDelivery: () => alertDelivery,
  alertDeliveryOutcome: () => alertDeliveryOutcome,
  alertDispatchedTo: () => alertDispatchedTo,
  alertExpiresAtMs: () => alertExpiresAtMs,
  alertGroupId: () => alertGroupId,
  alertRuleFromTriggerRule: () => alertRuleFromTriggerRule,
  alertRuleToTriggerRule: () => alertRuleToTriggerRule,
  alertSupersededAtMs: () => alertSupersededAtMs,
  alertSupersededBy: () => alertSupersededBy,
  alertTimestampMs: () => alertTimestampMs,
  alertTxHash: () => alertTxHash,
  constrainAlertRule: () => constrainAlertRule,
  defaultConfigFor: () => defaultConfigFor,
  destinationTarget: () => destinationTarget,
  emptyAlertRule: () => emptyAlertRule,
  emptyDestination: () => emptyDestination,
  isAlertAcknowledged: () => isAlertAcknowledged,
  isAlertSuperseded: () => isAlertSuperseded,
  severityToWire: () => severityToWire
});

// src/model/rule.ts
var rule_exports = {};
__export(rule_exports, {
  SEVERITY_TO_WIRE: () => SEVERITY_TO_WIRE,
  alertRuleFromTriggerRule: () => alertRuleFromTriggerRule,
  alertRuleToTriggerRule: () => alertRuleToTriggerRule,
  constrainAlertRule: () => constrainAlertRule,
  emptyAlertRule: () => emptyAlertRule,
  severityToWire: () => severityToWire
});
__reExport(rule_exports, triggers_star);
var SEVERITY_TO_WIRE = {
  [EventCriticality.CRITICAL]: "critical",
  [EventCriticality.HIGH]: "high",
  [EventCriticality.MEDIUM]: "medium",
  [EventCriticality.LOW]: "low",
  [EventCriticality.SUCCESS]: "info"
};
function severityToWire(severity) {
  return SEVERITY_TO_WIRE[severity] ?? "medium";
}
function emptyAlertRule(id) {
  return {
    id,
    name: "",
    enabled: true,
    severity: EventCriticality.HIGH,
    condition: anyCondition(),
    destinationIds: [],
    visibleToTeamIds: []
  };
}
function alertRuleToTriggerRule(rule) {
  return {
    ...emptyTriggerRule(rule.id),
    name: rule.name,
    description: rule.description ?? null,
    enabled: rule.enabled,
    condition: rule.condition,
    // An alert is a rule whose only actions are canonical `notify` actions
    // pointing at managed destinations.
    actions: rule.destinationIds.map((id) => triggerActionToRecord(notifyAction(id))),
    cooldown_seconds: rule.cooldownSeconds ?? 0,
    quiet_hours: rule.quietHours ? {
      start_hour: rule.quietHours.startHour,
      end_hour: rule.quietHours.endHour,
      timezone: rule.quietHours.timezone
    } : null,
    muted_until: rule.mutedUntil ?? null,
    // NOT `criticalityLabel(...).toLowerCase()`, which is what this was: the
    // UI ladder has a `SUCCESS` band with no rule meaning, and its label
    // lowercases to "success" — a value `TriggerSeverity` (info | low | medium |
    // high | critical) does not have. The dashboard's own adapter had a table
    // that mapped it to "info" and a comment explaining why; this one did not,
    // so the same rule saved differently depending on which adapter wrote it.
    // The table now lives here, once, and the dashboard reads it.
    severity: severityToWire(rule.severity),
    metadata: { criticality_level: rule.severity }
  };
}
function alertRuleFromTriggerRule(wire) {
  const metaLevel = wire.metadata?.criticality_level;
  const severity = typeof metaLevel === "number" ? criticalityFromName(metaLevel) : criticalityFromName(wire.severity ?? void 0, EventCriticality.HIGH);
  const destinationIds = (wire.actions ?? []).map((action) => parseTriggerAction(action)).filter((action) => action?.type === "notify").map((action) => action.destination_id);
  const quiet = wire.quiet_hours;
  return {
    id: wire.id,
    name: wire.name,
    description: wire.description ?? void 0,
    enabled: wire.enabled,
    severity,
    condition: wire.condition,
    destinationIds,
    cooldownSeconds: typeof wire.cooldown_seconds === "number" ? wire.cooldown_seconds : 0,
    quietHours: quiet ? {
      startHour: quiet.start_hour ?? 0,
      endHour: quiet.end_hour ?? 0,
      timezone: quiet.timezone ?? "UTC"
    } : void 0,
    mutedUntil: typeof wire.muted_until === "number" ? wire.muted_until : null
  };
}
function constrainAlertRule(rule, match) {
  return {
    ...rule,
    condition: and(match.condition, rule.condition),
    pipelineId: match.pipelineId,
    chainIds: match.chainIds
  };
}

// src/model/index.ts
__reExport(model_exports, rule_exports);

// src/model/destination.ts
var ALERT_CHANNELS = [
  "webhook",
  "email",
  "slack",
  "connector",
  "sns",
  "in_app",
  "discord"
];
var ALERT_AUTHORABLE_CHANNELS = ["webhook", "email", "slack", "connector"];
var ALERT_CHANNEL_LABELS = {
  webhook: "Webhook",
  email: "Email",
  slack: "Slack",
  // Named for what the user has, not for the backend's word. `connector` is the
  // `DestinationKind`; what the customer built and promoted is an
  // "integration", and that is the word the rest of the product uses for it.
  connector: "Integration",
  // Platform-configured, not customer-configured: an SNS topic is an account
  // resource and the in-app inbox has no address to set. Both are listed so a
  // reader can see where their alerts go; neither is authorable here.
  sns: "SNS topic",
  in_app: "In-app inbox",
  discord: "Discord"
};
function defaultConfigFor(channel) {
  switch (channel) {
    case "email":
      return { channel: "email", recipients: [] };
    case "slack":
      return { channel: "slack", webhookUrl: "" };
    case "connector":
      return { channel: "connector", connectorId: "" };
    case "sns":
    case "in_app":
      return { channel, raw: {} };
    case "discord":
      return { channel: "discord", webhookUrl: "" };
    case "webhook":
    default:
      return { channel: "webhook", url: "" };
  }
}
function emptyDestination(id, channel = "webhook") {
  return { id, name: "", enabled: true, config: defaultConfigFor(channel) };
}
function destinationTarget(destination) {
  const { config } = destination;
  switch (config.channel) {
    case "webhook":
      return config.url || "\u2014";
    case "email":
      return config.recipients.length ? config.recipients.join(", ") : "\u2014";
    case "slack":
      return config.channelName || config.webhookUrl || "\u2014";
    case "connector":
      return config.connectorId || "\u2014";
    case "sns":
      return typeof config.raw.topic_arn === "string" ? config.raw.topic_arn : "\u2014";
    case "in_app":
      return "Notification inbox";
    case "discord":
      return config.webhookUrl || "\u2014";
    default:
      return "\u2014";
  }
}
function alertCriticality(event) {
  return criticalityFromName(event.severity);
}
function alertTimestampMs(event) {
  const seconds = event.matched_at ?? event.created_at;
  return typeof seconds === "number" ? seconds * 1e3 : Date.now();
}
function alertTxHash(event) {
  return event.tx_hash ?? event.canonical_tx_id ?? "";
}
function groupIdOf(value) {
  if (typeof value !== "object" || value === null) return "";
  const id = value["group_id"];
  return typeof id === "string" ? id : "";
}
function alertGroupId(event) {
  if (event.group_id) return event.group_id;
  const matched = event.payload?.["matched_enrichments"];
  if (!Array.isArray(matched)) return "";
  for (const entry of matched) {
    if (typeof entry !== "object" || entry === null) continue;
    const found = groupIdOf(entry["payload"]);
    if (found) return found;
  }
  return "";
}
function alertDelivery(event) {
  const raw = event.delivery_status;
  if (typeof raw !== "object" || raw === null) return {};
  const out = {};
  for (const [id, state] of Object.entries(raw)) {
    if (typeof state === "string") out[id] = state;
  }
  return out;
}
function alertDispatchedTo(event) {
  const raw = event.dispatched_destination_ids;
  return Array.isArray(raw) ? raw.filter((id) => typeof id === "string" && id !== "") : [];
}
function alertDeliveryOutcome(event) {
  const states = Object.values(alertDelivery(event));
  if (states.length === 0) {
    return alertDispatchedTo(event).length > 0 ? "unknown" : "none";
  }
  if (states.some((s) => s === "failed")) return "failed";
  if (states.some((s) => s === "unknown")) return "unknown";
  if (states.some((s) => s === "pending")) return "pending";
  return "ok";
}
function alertAcknowledgedBy(event) {
  const by = event.acknowledged_by;
  return typeof by === "string" ? by : "";
}
function alertAcknowledgedAtMs(event) {
  const at = event.acknowledged_at;
  return typeof at === "number" ? at * 1e3 : null;
}
function isAlertAcknowledged(event) {
  return alertAcknowledgedAtMs(event) !== null;
}
function isAlertSuperseded(event) {
  return typeof event.superseded_at === "number";
}
function alertSupersededAtMs(event) {
  const at = event.superseded_at;
  return typeof at === "number" ? at * 1e3 : null;
}
function alertSupersededBy(event) {
  const by = event.superseded_by_tx_id;
  return typeof by === "string" ? by : "";
}
function alertExpiresAtMs(event) {
  const at = event.expires_at;
  return typeof at === "number" ? at * 1e3 : null;
}

// src/index.ts
__reExport(src_exports, model_exports);
function evaluateAlertRule(rule, envelope) {
  return evaluateRule(rule.condition, envelope);
}
function previewAlertRule(rule, envelopes, limit) {
  return previewRule(rule.condition, envelopes, limit);
}

// src/evaluation/fixtures.ts
var SAMPLE_ENVELOPES = [
  {
    canonical: {
      chain_id: "0x1",
      tx_hash: "0x9f2a1c7b4e8d6a3f5c0b9e2d1a8f7c6b5d4e3a2f1c0b9e8d7a6f5c4b3a2e1d0c",
      finality: "finalized",
      value: "5000000000000000000",
      block_number: 19e6,
      block_timestamp: "2026-05-20T12:00:00Z",
      events: [{ kind: "native_transfer" }, { kind: "log" }]
    },
    enrichment_layers: [
      {
        enrichments: [
          { kind: "tx_value_usd", source: "price-v2", payload: { total_usd: 145e5 } },
          {
            kind: "risk_score",
            source: "risk-v3.2",
            payload: { score: 91, bucket: "critical", policy_id: "default" }
          },
          { kind: "tag", source: "catalog", payload: { scope: "transaction", catalog_id: "mixer" } }
        ]
      }
    ]
  },
  {
    canonical: {
      chain_id: "0x89",
      tx_hash: "0x1b3d5f7a9c2e4068a1c3e5079b2d4f6a8c0e2147b3d5f7a9c1e3052749b6d8f0a",
      finality: "confirmed",
      value: "120000000000000000",
      block_number: 54e6,
      block_timestamp: "2026-05-21T09:30:00Z",
      events: [{ kind: "log" }]
    },
    enrichment_layers: [
      {
        enrichments: [
          { kind: "tx_value_usd", source: "price-v2", payload: { total_usd: 320 } },
          {
            kind: "risk_score",
            source: "risk-v3.2",
            payload: { score: 22, bucket: "low", policy_id: "default" }
          },
          { kind: "entity", source: "catalog", payload: { scope: "address", catalog_id: "uniswap" } }
        ]
      }
    ]
  },
  {
    canonical: {
      chain_id: "0x1",
      tx_hash: "0xa1f0e9d8c7b6a5f4e3d2c1b0a9f8e7d6c5b4a3f2e1d0c9b8a7f6e5d4c3b2a1f0",
      finality: "observed",
      value: "0",
      block_number: 19000512,
      block_timestamp: "2026-05-22T18:45:00Z",
      events: [{ kind: "log" }, { kind: "internal_tx" }]
    },
    enrichment_layers: [
      {
        enrichments: [
          { kind: "tx_value_usd", source: "price-v2", payload: { total_usd: 21e5 } },
          {
            kind: "risk_score",
            source: "risk-v3.2",
            payload: { score: 65, bucket: "high", policy_id: "sanctions" }
          },
          { kind: "label", source: "catalog", payload: { scope: "address", catalog_id: "ofac-sdn" } }
        ]
      }
    ]
  }
];

// src/data/source.ts
function createInMemoryAlertsSource(seed = {}, options = {}) {
  const pageSize = options.pageSize ?? 25;
  const rules = [...seed.rules ?? []];
  const destinations = [...seed.destinations ?? []];
  const history = [...seed.history ?? []];
  function upsert(list, item) {
    const idx = list.findIndex((entry) => entry.id === item.id);
    if (idx >= 0) list[idx] = item;
    else list.push(item);
    return item;
  }
  function remove(list, id) {
    const idx = list.findIndex((entry) => entry.id === id);
    if (idx >= 0) list.splice(idx, 1);
  }
  return {
    async listRules() {
      return [...rules];
    },
    async saveRule(rule) {
      return upsert(rules, rule);
    },
    async deleteRule(id) {
      remove(rules, id);
    },
    async listDestinations() {
      return [...destinations];
    },
    async saveDestination(destination) {
      return upsert(destinations, destination);
    },
    async deleteDestination(id) {
      remove(destinations, id);
    },
    async acknowledgeAlert(id) {
      const at = history.findIndex((event2) => event2.id === id);
      if (at < 0) throw new Error(`no such alert: ${id}`);
      const event = history[at];
      if (typeof event.acknowledged_at === "number") return event;
      const next = {
        ...event,
        acknowledged_at: Math.floor(Date.now() / 1e3),
        acknowledged_by: "in-memory-actor"
      };
      history[at] = next;
      return next;
    },
    async fetchHistory({ cursor, limit }) {
      const start = cursor ? Number(cursor) || 0 : 0;
      const size = limit ?? pageSize;
      const items = history.slice(start, start + size);
      const next = start + size;
      return { items, nextCursor: next < history.length ? String(next) : null };
    }
  };
}
function createApiAlertsSource(client, options = {}) {
  const rulesPath = options.rulesPath ?? "/alert-rules";
  const destinationsPath = options.destinationsPath ?? "/alert-destinations";
  const historyPath = options.historyPath ?? "/alert-history";
  return {
    async listRules() {
      return unwrapData(await client.get(rulesPath));
    },
    async saveRule(rule) {
      return unwrapData(await client.put(`${rulesPath}/${encodeURIComponent(rule.id)}`, rule));
    },
    async deleteRule(id) {
      unwrapData(await client.delete(`${rulesPath}/${encodeURIComponent(id)}`));
    },
    async listDestinations() {
      return unwrapData(await client.get(destinationsPath));
    },
    async saveDestination(destination) {
      return unwrapData(
        await client.put(
          `${destinationsPath}/${encodeURIComponent(destination.id)}`,
          destination
        )
      );
    },
    async deleteDestination(id) {
      unwrapData(await client.delete(`${destinationsPath}/${encodeURIComponent(id)}`));
    },
    async fetchHistory(query) {
      const res = unwrapResponse(
        await client.get(historyPath, {
          query: { cursor: query.cursor, limit: query.limit }
        })
      );
      return { items: res.data ?? [], nextCursor: res.pagination?.next ?? null };
    },
    async previewRule(rule) {
      return unwrapData(await client.post(`${rulesPath}/preview`, rule));
    }
  };
}
var log = createLogger(ALERTS_PACKAGE);
function useCollection(port, label) {
  const [items, setItems] = React3.useState([]);
  const [status, setStatus] = React3.useState("idle");
  const [error, setError] = React3.useState(null);
  const refresh = React3.useCallback(() => {
    setStatus((s) => s === "ready" ? "ready" : "loading");
    setError(null);
    port.list().then(
      (list) => {
        setItems(list);
        setStatus("ready");
      },
      (err) => {
        log.error(`${label}.list failed`, { error: String(err) });
        setError(err);
        setStatus("error");
      }
    );
  }, [port, label]);
  React3.useEffect(() => {
    refresh();
  }, [refresh]);
  const save = React3.useCallback(
    async (item) => {
      try {
        const saved = await port.save(item);
        setItems((prev) => {
          const idx = prev.findIndex((p) => p.id === saved.id);
          if (idx >= 0) {
            const next = [...prev];
            next[idx] = saved;
            return next;
          }
          return [...prev, saved];
        });
        notifySuccess(`${label} saved`);
        return saved;
      } catch (err) {
        log.error(`${label}.save failed`, { error: String(err) });
        notifyError(err);
        return void 0;
      }
    },
    [port, label]
  );
  const remove = React3.useCallback(
    async (id) => {
      const at = items.findIndex((p) => p.id === id);
      const removed = at >= 0 ? items[at] : void 0;
      setItems((cur) => cur.filter((p) => p.id !== id));
      try {
        await port.remove(id);
      } catch (err) {
        log.error(`${label}.remove failed`, { error: String(err) });
        notifyError(err);
        if (removed) {
          setItems((cur) => {
            if (cur.some((p) => p.id === id)) return cur;
            const next = [...cur];
            next.splice(Math.min(at, next.length), 0, removed);
            return next;
          });
        }
      }
    },
    [items, port, label]
  );
  return { items, status, error, refresh, save, remove };
}

// src/data/useAlertRules.ts
function useAlertRules(source) {
  const port = React3.useMemo(
    () => ({
      list: () => source.listRules(),
      save: (rule) => source.saveRule(rule),
      remove: (id) => source.deleteRule(id)
    }),
    [source]
  );
  return useCollection(port, "Rule");
}
function useAlertDestinations(source) {
  const port = React3.useMemo(
    () => ({
      list: () => source.listDestinations(),
      save: (destination) => source.saveDestination(destination),
      remove: (id) => source.deleteDestination(id)
    }),
    [source]
  );
  return useCollection(port, "Destination");
}
var log2 = createLogger(ALERTS_PACKAGE);
function useAlertHistory(source, {
  pageSize = ALERTS_HISTORY_PAGE_SIZE,
  autoLoad = true,
  ruleId = null
} = {}) {
  const [events, setEvents] = React3.useState([]);
  const [status, setStatus] = React3.useState("idle");
  const [error, setError] = React3.useState(null);
  const [cursor, setCursor] = React3.useState(null);
  const [hasMore, setHasMore] = React3.useState(false);
  const runRef = React3.useRef(0);
  const loadingRef = React3.useRef(false);
  const loadedHeadRef = React3.useRef(false);
  const loadedIdsRef = React3.useRef(/* @__PURE__ */ new Set());
  const load = React3.useCallback(
    async (nextCursor, refreshHead = false) => {
      if (loadingRef.current) return;
      loadingRef.current = true;
      const runId = ++runRef.current;
      setStatus((s) => s === "ready" ? "ready" : "loading");
      setError(null);
      try {
        const page = await source.fetchHistory({
          cursor: nextCursor,
          limit: pageSize,
          ruleId
        });
        if (runId !== runRef.current) return;
        const keepPagination = refreshHead && loadedHeadRef.current && (!page.nextCursor || page.items.some((event) => event.id != null && loadedIdsRef.current.has(event.id)));
        if (refreshHead && !keepPagination) loadedIdsRef.current.clear();
        for (const event of page.items) if (event.id != null) loadedIdsRef.current.add(event.id);
        setEvents((prev) => {
          const retained = refreshHead && !keepPagination ? [] : prev;
          const ordered = refreshHead ? [...page.items, ...retained] : [...retained, ...page.items];
          const byId = new Map(ordered.map((e) => [e.id, e]));
          for (const event of page.items) byId.set(event.id, event);
          return [...byId.values()];
        });
        if (!keepPagination) {
          setCursor(page.nextCursor ?? null);
          setHasMore(Boolean(page.nextCursor));
        }
        loadedHeadRef.current = true;
        setStatus("ready");
      } catch (err) {
        if (runId !== runRef.current) return;
        log2.error("fetchHistory failed", { error: String(err) });
        setError(err);
        setStatus("error");
      } finally {
        if (runId === runRef.current) loadingRef.current = false;
      }
    },
    [source, pageSize, ruleId]
  );
  React3.useEffect(() => {
    runRef.current += 1;
    loadingRef.current = false;
    loadedHeadRef.current = false;
    loadedIdsRef.current.clear();
    setEvents([]);
    setCursor(null);
    setHasMore(false);
    if (autoLoad) void load(null);
  }, [source, ruleId]);
  const loadMore = React3.useCallback(() => {
    if (hasMore) void load(cursor);
  }, [hasMore, cursor, load]);
  const [acknowledging, setAcknowledging] = React3.useState(
    () => /* @__PURE__ */ new Set()
  );
  const canAcknowledge = typeof source.acknowledgeAlert === "function";
  const acknowledge = React3.useCallback(
    async (id) => {
      const ack = source.acknowledgeAlert;
      if (!ack) return;
      setAcknowledging((prev) => new Set(prev).add(id));
      try {
        const updated = await ack.call(source, id);
        setEvents((prev) => prev.map((event) => event.id === id ? updated : event));
      } catch (err) {
        log2.error("acknowledgeAlert failed", { error: String(err) });
        throw err;
      } finally {
        setAcknowledging((prev) => {
          const next = new Set(prev);
          next.delete(id);
          return next;
        });
      }
    },
    [source]
  );
  const refresh = React3.useCallback(() => {
    runRef.current += 1;
    loadingRef.current = false;
    void load(null, true);
  }, [load]);
  return {
    events,
    status,
    error,
    hasMore,
    loadMore,
    refresh,
    canAcknowledge,
    acknowledge,
    acknowledging
  };
}
function DestinationEditor({
  value,
  onChange,
  onSave,
  onCancel,
  connectors = []
}) {
  const { config } = value;
  const managedElsewhere = config.channel === "sns" || config.channel === "in_app";
  const changeChannel = (channel) => onChange({ ...value, config: defaultConfigFor(channel) });
  return /* @__PURE__ */ jsxs(Card, { children: [
    /* @__PURE__ */ jsx(CardHeader, { children: /* @__PURE__ */ jsx(CardTitle, { children: value.name ? `Edit \u201C${value.name}\u201D` : "New destination" }) }),
    /* @__PURE__ */ jsxs(CardContent, { className: "space-y-4", children: [
      /* @__PURE__ */ jsx(Field, { label: "Name", children: /* @__PURE__ */ jsx(
        Input,
        {
          value: value.name,
          placeholder: "e.g. On-call webhook",
          onChange: (e) => onChange({ ...value, name: e.target.value })
        }
      ) }),
      /* @__PURE__ */ jsx(Field, { label: "Channel", ownsControl: true, children: /* @__PURE__ */ jsxs(
        Select,
        {
          value: config.channel,
          disabled: managedElsewhere,
          onValueChange: (v) => changeChannel(v),
          children: [
            /* @__PURE__ */ jsx(FormControl, { children: /* @__PURE__ */ jsx(SelectTrigger, { className: "w-56", children: /* @__PURE__ */ jsx(SelectValue, {}) }) }),
            /* @__PURE__ */ jsx(SelectContent, { children: ALERT_AUTHORABLE_CHANNELS.map((channel) => /* @__PURE__ */ jsx(SelectItem, { value: channel, children: ALERT_CHANNEL_LABELS[channel] }, channel)) })
          ]
        }
      ) }),
      config.channel === "webhook" && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Field, { label: "Webhook URL", children: /* @__PURE__ */ jsx(
          Input,
          {
            value: config.url,
            placeholder: "https://example.com/hooks/alerts",
            onChange: (e) => onChange({ ...value, config: { ...config, url: e.target.value } })
          }
        ) }),
        /* @__PURE__ */ jsx(Field, { label: "Signing secret (optional)", children: /* @__PURE__ */ jsx(
          Input,
          {
            type: "password",
            value: config.secret ?? "",
            onChange: (e) => onChange({ ...value, config: { ...config, secret: e.target.value } })
          }
        ) })
      ] }),
      config.channel === "email" && /* @__PURE__ */ jsx(Field, { label: "Recipients (comma-separated)", children: /* @__PURE__ */ jsx(
        Input,
        {
          value: config.recipients.join(", "),
          placeholder: "ops@authe.io, security@authe.io",
          onChange: (e) => onChange({
            ...value,
            config: {
              ...config,
              recipients: e.target.value.split(",").map((s) => s.trim()).filter(Boolean)
            }
          })
        }
      ) }),
      managedElsewhere && /* @__PURE__ */ jsxs("p", { className: "text-sm text-muted-foreground", children: [
        ALERT_CHANNEL_LABELS[config.channel],
        " destinations are configured for the whole deployment, not per tenant. You can rename this one or turn it off; its target is not editable here."
      ] }),
      config.channel === "connector" && /* @__PURE__ */ jsx(Field, { label: "Integration", ownsControl: true, children: connectors.length === 0 ? (
        // The same rule the pipeline builder's picker follows: an empty
        // picker is unanswerable, so say which of the two reasons it is.
        // Both have a fix, and they are different fixes.
        /* @__PURE__ */ jsx("p", { className: "text-sm text-muted-foreground", children: "No integration is published yet. Write one in the code editor, then promote a build on the Integrations page \u2014 an integration that has never been promoted cannot receive an alert." })
      ) : /* @__PURE__ */ jsxs(
        Select,
        {
          value: config.connectorId || void 0,
          onValueChange: (connectorId) => onChange({ ...value, config: { ...config, connectorId } }),
          children: [
            /* @__PURE__ */ jsx(FormControl, { children: /* @__PURE__ */ jsx(SelectTrigger, { className: "w-full", children: /* @__PURE__ */ jsx(SelectValue, { placeholder: "Choose an integration\u2026" }) }) }),
            /* @__PURE__ */ jsx(SelectContent, { children: connectors.map((connector) => /* @__PURE__ */ jsx(SelectItem, { value: connector.id, children: connector.name }, connector.id)) })
          ]
        }
      ) }),
      (config.channel === "slack" || config.channel === "discord") && /* @__PURE__ */ jsx(Field, { label: `${ALERT_CHANNEL_LABELS[config.channel]} webhook URL`, children: /* @__PURE__ */ jsx(
        Input,
        {
          value: config.webhookUrl,
          placeholder: "https://hooks.slack.com/services/\u2026",
          onChange: (e) => onChange({ ...value, config: { ...config, webhookUrl: e.target.value } })
        }
      ) }),
      /* @__PURE__ */ jsx(
        Field,
        {
          label: "Enabled",
          orientation: "horizontal",
          reverse: true,
          labelClassName: "text-sm text-muted-foreground",
          children: /* @__PURE__ */ jsx(
            Switch,
            {
              checked: value.enabled,
              onCheckedChange: (checked) => onChange({ ...value, enabled: checked })
            }
          )
        }
      ),
      (onSave || onCancel) && /* @__PURE__ */ jsxs("div", { className: "flex justify-end gap-2 pt-2", children: [
        onCancel && /* @__PURE__ */ jsx(Button, { variant: "ghost", onClick: onCancel, children: "Cancel" }),
        onSave && /* @__PURE__ */ jsx(Button, { variant: "brand", disabled: !value.name.trim(), onClick: () => onSave(value), children: "Save destination" })
      ] })
    ] })
  ] });
}
function DestinationList({
  controller,
  onEdit,
  canMutate = true,
  className
}) {
  const { items, status, error, refresh, save, remove } = controller;
  const [confirming, setConfirming] = React3.useState(null);
  if (status === "error") return /* @__PURE__ */ jsx(ErrorState, { error, onRetry: refresh });
  if (status === "loading" && items.length === 0) {
    return /* @__PURE__ */ jsx("div", { className: "space-y-2", "aria-busy": true, children: Array.from({ length: 3 }).map((_, i) => /* @__PURE__ */ jsx(Skeleton, { className: "h-12 w-full" }, i)) });
  }
  if (items.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: "No destinations yet",
        description: "Add a webhook, an email address, a Slack channel, or one of your own integrations to route alerts to.",
        size: "sm"
      }
    );
  }
  return /* @__PURE__ */ jsx("ul", { className: cn("divide-y divide-border rounded-md border", className), children: items.map((destination) => /* @__PURE__ */ jsxs("li", { className: "flex items-center gap-3 px-3 py-2.5", children: [
    /* @__PURE__ */ jsxs("div", { className: "min-w-0 flex-1", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx("span", { className: "truncate text-sm font-medium", children: destination.name || "Untitled" }),
        /* @__PURE__ */ jsx(Badge, { variant: "secondary", children: ALERT_CHANNEL_LABELS[destination.config.channel] })
      ] }),
      /* @__PURE__ */ jsx("p", { className: "truncate text-xs text-muted-foreground", children: destinationTarget(destination) })
    ] }),
    canMutate ? /* @__PURE__ */ jsx(
      Switch,
      {
        checked: destination.enabled,
        "aria-label": `${destination.enabled ? "Disable" : "Enable"} ${destination.name}`,
        onCheckedChange: (checked) => void save({ ...destination, enabled: checked })
      }
    ) : (
      // Still SAID, just not changeable: "this destination is off" is the
      // explanation for an alert that reached nobody, and a reader
      // triaging that needs to see it.
      /* @__PURE__ */ jsx(Badge, { variant: destination.enabled ? "outline" : "secondary", children: destination.enabled ? "Enabled" : "Disabled" })
    ),
    canMutate && onEdit && /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: () => onEdit(destination), children: "Edit" }),
    canMutate && // Asked for, not just done. The removal is optimistic and the row
    // is gone from the backend the moment it succeeds, so there is
    // nothing to undo — and every rule routed through this destination
    // silently stops reaching anyone. That is the same consequence a
    // deleted alert rule has, and rules already confirm.
    /* @__PURE__ */ jsxs(
      AlertDialog,
      {
        open: confirming === destination.id,
        onOpenChange: (open) => setConfirming(open ? destination.id : null),
        children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "sm",
              className: "text-destructive hover:text-destructive",
              onClick: () => setConfirming(destination.id),
              children: "Delete"
            }
          ),
          /* @__PURE__ */ jsxs(AlertDialogContent, { children: [
            /* @__PURE__ */ jsxs(AlertDialogHeader, { children: [
              /* @__PURE__ */ jsxs(AlertDialogTitle, { children: [
                "Delete \u201C",
                destination.name || "Untitled",
                "\u201D?"
              ] }),
              /* @__PURE__ */ jsx(AlertDialogDescription, { children: "Any alert rule pointing here stops reaching it immediately, and the rules themselves are not changed \u2014 they will keep matching and delivering to nothing. This cannot be undone." })
            ] }),
            /* @__PURE__ */ jsxs(AlertDialogFooter, { children: [
              /* @__PURE__ */ jsx(AlertDialogCancel, { children: "Cancel" }),
              /* @__PURE__ */ jsx(
                AlertDialogAction,
                {
                  className: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
                  onClick: () => void remove(destination.id),
                  children: "Delete destination"
                }
              )
            ] })
          ] })
        ]
      }
    )
  ] }, destination.id)) });
}
function TriggerRuleEditor({
  value,
  onChange,
  destinations = [],
  onSave,
  onCancel,
  saving = false,
  emptyConditionsDescription = "No conditions \u2014 add one to start matching."
}) {
  const [tab, setTab] = React3.useState("builder");
  const [draft, setDraft] = React3.useState(() => JSON.stringify(value, null, 2));
  const [jsonError, setJsonError] = React3.useState(null);
  const condition = useFlatCondition(value.condition, (next) => onChange({ ...value, condition: next }));
  const handleTabChange = (next) => {
    if (next === "advanced") {
      setDraft(JSON.stringify(value, null, 2));
      setJsonError(null);
    }
    setTab(next);
  };
  const applyJson = () => {
    try {
      onChange(JSON.parse(draft));
      setJsonError(null);
    } catch (err) {
      setJsonError(err.message);
    }
  };
  const toggleDestination = (destinationId, checked) => onChange({
    ...value,
    destinationIds: checked ? [...value.destinationIds, destinationId] : value.destinationIds.filter((id) => id !== destinationId)
  });
  return /* @__PURE__ */ jsxs("div", { className: "space-y-4", children: [
    /* @__PURE__ */ jsx(Field, { label: "Rule name", children: /* @__PURE__ */ jsx(
      Input,
      {
        value: value.name,
        placeholder: "e.g. Large outbound transfer",
        onChange: (e) => onChange({ ...value, name: e.target.value })
      }
    ) }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-end gap-4", children: [
      /* @__PURE__ */ jsx(Field, { label: "Severity", ownsControl: true, children: /* @__PURE__ */ jsxs(
        Select,
        {
          value: String(value.severity),
          onValueChange: (v) => onChange({ ...value, severity: Number(v) }),
          children: [
            /* @__PURE__ */ jsx(FormControl, { children: /* @__PURE__ */ jsx(SelectTrigger, { className: "w-40", children: /* @__PURE__ */ jsx(SelectValue, {}) }) }),
            /* @__PURE__ */ jsx(SelectContent, { children: EVENT_CRITICALITY_ORDER.map((level) => /* @__PURE__ */ jsx(SelectItem, { value: String(level), children: criticalityLabel(level) }, level)) })
          ]
        }
      ) }),
      /* @__PURE__ */ jsx(Field, { label: "Match", ownsControl: true, children: /* @__PURE__ */ jsxs(
        Select,
        {
          value: condition.match,
          disabled: condition.nested,
          onValueChange: (v) => condition.setMatch(v),
          children: [
            /* @__PURE__ */ jsx(FormControl, { children: /* @__PURE__ */ jsx(
              SelectTrigger,
              {
                className: "w-40",
                "aria-label": "Condition match mode",
                title: condition.nested ? "Edit the nested condition as JSON to change its match mode" : void 0,
                children: /* @__PURE__ */ jsx(SelectValue, {})
              }
            ) }),
            /* @__PURE__ */ jsxs(SelectContent, { children: [
              /* @__PURE__ */ jsx(SelectItem, { value: "all", children: "All conditions" }),
              /* @__PURE__ */ jsx(SelectItem, { value: "any", children: "Any condition" })
            ] })
          ]
        }
      ) }),
      /* @__PURE__ */ jsx(
        Field,
        {
          label: "Enabled",
          orientation: "horizontal",
          reverse: true,
          rowClassName: "pb-2",
          labelClassName: "text-sm text-muted-foreground",
          children: /* @__PURE__ */ jsx(
            Switch,
            {
              checked: value.enabled,
              onCheckedChange: (checked) => onChange({ ...value, enabled: checked })
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ jsxs(Tabs, { value: tab, onValueChange: handleTabChange, children: [
      /* @__PURE__ */ jsxs(TabsList, { children: [
        /* @__PURE__ */ jsx(TabsTrigger, { value: "builder", children: "Builder" }),
        /* @__PURE__ */ jsx(TabsTrigger, { value: "advanced", children: "Advanced (JSON)" })
      ] }),
      /* @__PURE__ */ jsxs(TabsContent, { value: "builder", className: "space-y-3 pt-3", children: [
        condition.nested ? /* @__PURE__ */ jsxs("p", { className: "text-sm text-muted-foreground", children: [
          "This rule uses a nested condition the visual builder can't display. Edit it in the ",
          /* @__PURE__ */ jsx("span", { className: "font-medium text-foreground", children: "Advanced (JSON)" }),
          " tab."
        ] }) : /* @__PURE__ */ jsx(ConditionRows, { state: condition, emptyDescription: emptyConditionsDescription }),
        destinations.length > 0 && /* @__PURE__ */ jsx(Field, { label: "Destinations", className: "pt-2", children: /* @__PURE__ */ jsx("div", { className: "space-y-1.5", children: destinations.map((destination) => /* @__PURE__ */ jsxs("label", { className: "flex items-center gap-2 text-sm", children: [
          /* @__PURE__ */ jsx(
            Checkbox,
            {
              checked: value.destinationIds.includes(destination.id),
              onCheckedChange: (checked) => toggleDestination(destination.id, checked)
            }
          ),
          /* @__PURE__ */ jsx("span", { children: destination.name || "Untitled" }),
          /* @__PURE__ */ jsx(Badge, { variant: "secondary", children: ALERT_CHANNEL_LABELS[destination.config.channel] })
        ] }, destination.id)) }) })
      ] }),
      /* @__PURE__ */ jsxs(TabsContent, { value: "advanced", className: "space-y-2 pt-3", children: [
        /* @__PURE__ */ jsx(JsonEditor, { value: draft, onChange: setDraft, height: ALERTS_RULE_EDITOR_HEIGHT }),
        jsonError && /* @__PURE__ */ jsxs("p", { className: "text-sm text-destructive", children: [
          "Invalid JSON: ",
          jsonError
        ] }),
        /* @__PURE__ */ jsx(Button, { variant: "outline", size: "sm", onClick: applyJson, children: "Apply JSON" })
      ] })
    ] }),
    (onSave || onCancel) && /* @__PURE__ */ jsxs("div", { className: "flex justify-end gap-2 border-t pt-3", children: [
      onCancel && /* @__PURE__ */ jsx(Button, { variant: "ghost", onClick: onCancel, children: "Cancel" }),
      onSave && /* @__PURE__ */ jsx(Button, { variant: "brand", disabled: saving || !value.name.trim(), onClick: () => onSave(value), children: saving ? "Saving\u2026" : "Save rule" })
    ] })
  ] });
}
function RulePreview({
  rule,
  fixtures,
  limit = ALERTS_PREVIEW_LIMIT,
  className
}) {
  const settled = useDebounced(rule, ALERTS_PREVIEW_DEBOUNCE_MS);
  const matches = React3.useMemo(
    () => previewAlertRule(settled, fixtures, limit),
    [settled, fixtures, limit]
  );
  const predicates = React3.useMemo(
    () => flattenCondition(rule.condition)?.predicates ?? [],
    [rule.condition]
  );
  return /* @__PURE__ */ jsxs("div", { className: cn("space-y-3", className), children: [
    /* @__PURE__ */ jsxs("p", { className: "text-sm text-muted-foreground", children: [
      /* @__PURE__ */ jsx("span", { className: "font-semibold text-foreground", children: matches.length }),
      " of ",
      fixtures.length,
      " ",
      "sample transactions would fire this rule."
    ] }),
    matches.length === 0 ? /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: "No sample matches",
        description: "Adjust the conditions or try a different fixture set.",
        size: "sm"
      }
    ) : /* @__PURE__ */ jsx("ul", { className: "divide-y divide-border rounded-md border", children: matches.map(({ envelope, evaluation }, idx) => {
      const canonical = envelope.canonical ?? {};
      const hash = valueText(canonical.tx_hash);
      const chain = valueText(canonical.chain_id) || void 0;
      const passed = predicates.filter((p) => evaluatePredicate(p, envelope));
      return /* @__PURE__ */ jsxs("li", { className: "flex flex-col gap-1.5 px-3 py-2.5", children: [
        hash ? /* @__PURE__ */ jsx(HashDisplay, { hash, chain }) : /* @__PURE__ */ jsx("span", { className: "text-sm text-muted-foreground", children: "(unlabelled transaction)" }),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap gap-1.5", children: [
          passed.map((p, i) => /* @__PURE__ */ jsxs(Badge, { variant: "outline", className: "font-normal", children: [
            triggerFieldLabel(p.field),
            " ",
            TRIGGER_OPERATOR_LABELS[p.op],
            " ",
            valueText(p.value)
          ] }, `pred-${i}`)),
          evaluation.matchedEnrichments.map((e, i) => /* @__PURE__ */ jsx(Badge, { variant: "secondary", className: "font-normal", children: e.kind }, `enr-${i}`))
        ] })
      ] }, hash || idx);
    }) })
  ] });
}
var COOLDOWNS = [
  { value: 0, label: "No cooldown \u2014 alert on every match" },
  { value: 300, label: "At most once every 5 minutes" },
  { value: 900, label: "At most once every 15 minutes" },
  { value: 3600, label: "At most once an hour" },
  { value: 21600, label: "At most once every 6 hours" },
  { value: 86400, label: "At most once a day" }
];
var START_HOURS = Array.from({ length: 24 }, (_, hour) => hour);
var END_HOURS = Array.from({ length: 24 }, (_, hour) => hour + 1);
function hourLabel(hour) {
  if (hour === 24) return "midnight";
  return `${String(hour).padStart(2, "0")}:00`;
}
var KNOWN_ZONES = (() => {
  try {
    return Intl.supportedValuesOf?.("timeZone") ?? [];
  } catch {
    return [];
  }
})();
function isKnownZone(name) {
  if (!name.trim()) return false;
  try {
    new Intl.DateTimeFormat(void 0, { timeZone: name });
    return true;
  } catch {
    return false;
  }
}
function localZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}
function NoiseControls({ value, onChange }) {
  const quiet = value.quietHours;
  const zoneListId = `${React3.useId()}-zones`;
  const zoneRejected = Boolean(quiet) && !isKnownZone(quiet?.timezone ?? "");
  const emptyWindow = Boolean(quiet) && quiet?.startHour === quiet?.endHour;
  const setQuiet = (patch) => onChange({
    ...value,
    quietHours: {
      startHour: quiet?.startHour ?? 22,
      endHour: quiet?.endHour ?? 7,
      timezone: quiet?.timezone ?? localZone(),
      ...patch
    }
  });
  return /* @__PURE__ */ jsxs("div", { className: "space-y-3 rounded-md border p-3", children: [
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("div", { className: "text-sm font-medium", children: "How often this can alert" }),
      /* @__PURE__ */ jsx("p", { className: "mt-0.5 text-xs text-muted-foreground", children: "A busy address can match hundreds of times an hour. These bound what reaches you without changing what the rule matches." })
    ] }),
    /* @__PURE__ */ jsx(Field, { label: "Cooldown", children: /* @__PURE__ */ jsxs(
      Select,
      {
        value: String(value.cooldownSeconds ?? 0),
        onValueChange: (next) => onChange({ ...value, cooldownSeconds: Number(next) }),
        children: [
          /* @__PURE__ */ jsx(SelectTrigger, { children: /* @__PURE__ */ jsx(SelectValue, {}) }),
          /* @__PURE__ */ jsx(SelectContent, { children: COOLDOWNS.map((option) => /* @__PURE__ */ jsx(SelectItem, { value: String(option.value), children: option.label }, option.value)) })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx(
      Field,
      {
        label: "Quiet hours",
        error: zoneRejected ? `\u201C${quiet?.timezone ?? ""}\u201D is not an IANA time zone, so this window would be evaluated in UTC instead. Pick one like \u201CEurope/Amsterdam\u201D.` : void 0,
        hint: emptyWindow ? `Start and end are both ${hourLabel(quiet?.startHour ?? 0)}, which silences nothing. Choose \u201Cmidnight\u201D as the end to stay quiet to the end of the day.` : void 0,
        children: quiet ? /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [
          /* @__PURE__ */ jsxs(
            Select,
            {
              value: String(quiet.startHour),
              onValueChange: (next) => setQuiet({ startHour: Number(next) }),
              children: [
                /* @__PURE__ */ jsx(SelectTrigger, { className: "w-28", children: /* @__PURE__ */ jsx(SelectValue, {}) }),
                /* @__PURE__ */ jsx(SelectContent, { children: START_HOURS.map((hour) => /* @__PURE__ */ jsx(SelectItem, { value: String(hour), children: hourLabel(hour) }, hour)) })
              ]
            }
          ),
          /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: "until" }),
          /* @__PURE__ */ jsxs(
            Select,
            {
              value: String(quiet.endHour),
              onValueChange: (next) => setQuiet({ endHour: Number(next) }),
              children: [
                /* @__PURE__ */ jsx(SelectTrigger, { className: "w-28", children: /* @__PURE__ */ jsx(SelectValue, {}) }),
                /* @__PURE__ */ jsx(SelectContent, { children: END_HOURS.map((hour) => /* @__PURE__ */ jsx(SelectItem, { value: String(hour), children: hourLabel(hour) }, hour)) })
              ]
            }
          ),
          /* @__PURE__ */ jsx(
            Input,
            {
              "aria-label": "Time zone",
              className: "w-48 font-mono text-xs",
              list: KNOWN_ZONES.length > 0 ? zoneListId : void 0,
              "aria-invalid": zoneRejected || void 0,
              value: quiet.timezone,
              onChange: (e) => setQuiet({ timezone: e.target.value })
            }
          ),
          KNOWN_ZONES.length > 0 ? /* @__PURE__ */ jsx("datalist", { id: zoneListId, children: KNOWN_ZONES.map((zone) => /* @__PURE__ */ jsx("option", { value: zone }, zone)) }) : null,
          /* @__PURE__ */ jsx(
            Button,
            {
              type: "button",
              variant: "ghost",
              size: "sm",
              onClick: () => onChange({ ...value, quietHours: void 0 }),
              children: "Remove"
            }
          )
        ] }) : /* @__PURE__ */ jsx(Button, { type: "button", variant: "outline", size: "sm", onClick: () => setQuiet({}), children: "Stay quiet overnight" })
      }
    ),
    /* @__PURE__ */ jsx(Field, { label: "Muted", children: /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [
      /* @__PURE__ */ jsx(
        Input,
        {
          type: "date",
          className: "w-44",
          value: typeof value.mutedUntil === "number" ? new Date(value.mutedUntil * 1e3).toISOString().slice(0, 10) : "",
          onChange: (e) => onChange({
            ...value,
            mutedUntil: e.target.value ? Math.floor((/* @__PURE__ */ new Date(`${e.target.value}T00:00:00Z`)).getTime() / 1e3) : null
          })
        }
      ),
      /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: typeof value.mutedUntil === "number" ? "Silent until this date. The rule stays on and keeps its history." : "Not muted \u2014 every match alerts, subject to the cooldown above." })
    ] }) })
  ] });
}
var COLUMNS = [
  {
    id: "severity",
    accessorFn: (event) => alertCriticality(event),
    // Declared widths for the columns whose content has a known size, so Rule
    // and Findings take what is left. With none declared every column got the
    // same 120px floor: nine of them needed 1080px of a 990px card, "Watch:
    // Uniswap Watch" wrapped onto three lines beside a Chain column with room to
    // spare, and the Acknowledge button sat behind a horizontal scroll.
    size: 108,
    header: ({ column }) => /* @__PURE__ */ jsx(DataTableColumnHeader, { column, title: "Severity" }),
    cell: ({ row }) => /* @__PURE__ */ jsx(CriticalityBadge, { level: alertCriticality(row.original) })
  },
  {
    id: "rule",
    accessorFn: (event) => event.rule_name || event.rule_id,
    minSize: 110,
    header: ({ column }) => /* @__PURE__ */ jsx(DataTableColumnHeader, { column, title: "Rule" }),
    cell: ({ row }) => {
      const name = row.original.rule_name || row.original.rule_id;
      if (!isAlertSuperseded(row.original)) {
        return /* @__PURE__ */ jsx("span", { className: "font-medium", children: name });
      }
      const at = alertSupersededAtMs(row.original);
      const by = alertSupersededBy(row.original);
      return /* @__PURE__ */ jsxs("span", { className: "flex min-w-0 items-center gap-1.5", children: [
        /* @__PURE__ */ jsx("span", { className: "truncate font-medium line-through opacity-60", children: name }),
        /* @__PURE__ */ jsx(
          Badge,
          {
            variant: "outline",
            className: "shrink-0 text-[10px]",
            title: [
              "This transaction was reorged out of the chain.",
              by ? `Replaced by ${by}.` : "No replacement transaction is known.",
              at === null ? "" : formatTimestamp(at, { unit: "milliseconds" })
            ].filter(Boolean).join(" "),
            children: "Reorged"
          }
        )
      ] });
    }
  },
  {
    id: "tx_hash",
    accessorFn: (event) => alertTxHash(event),
    size: 120,
    header: "Transaction",
    enableSorting: false,
    cell: ({ row }) => {
      const hash = alertTxHash(row.original);
      if (!hash) return /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "\u2014" });
      return /* @__PURE__ */ jsx(HashDisplay, { hash, chain: row.original.chain_id ?? void 0 });
    }
  },
  {
    id: "chain_id",
    size: 104,
    // Friendly name for search/sort; the cell still keys off the raw id.
    accessorFn: (event) => event.chain_id ? chainDisplayName(event.chain_id) : "",
    header: "Chain",
    cell: ({ row }) => {
      const chain = row.original.chain_id;
      if (!chain) return /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "\u2014" });
      return /* @__PURE__ */ jsx(ChainAvatar, { chain, size: "sm", showName: true });
    }
  },
  {
    id: "delivery",
    accessorFn: (event) => alertDeliveryOutcome(event),
    size: 92,
    header: "Delivered",
    enableSorting: false,
    cell: ({ row }) => {
      const outcome = alertDeliveryOutcome(row.original);
      if (outcome === "none") {
        return /* @__PURE__ */ jsx(
          "span",
          {
            className: "text-xs text-muted-foreground",
            title: "This rule names no destinations \u2014 it fires into the history below and notifies nobody.",
            children: "\u2014"
          }
        );
      }
      const detail = Object.entries(alertDelivery(row.original)).map(([id, state]) => `${id}: ${state}`).join("\n");
      const variant = outcome === "ok" ? "outline" : outcome === "failed" ? "destructive" : "secondary";
      return /* @__PURE__ */ jsx(Badge, { variant, className: "text-[10px]", title: detail, children: DELIVERY_LABELS[outcome] });
    }
  },
  {
    id: "when",
    accessorFn: (event) => alertTimestampMs(event),
    size: 112,
    header: ({ column }) => /* @__PURE__ */ jsx(DataTableColumnHeader, { column, title: "When" }),
    cell: ({ row }) => {
      const ms = alertTimestampMs(row.original);
      return /* @__PURE__ */ jsx(
        "span",
        {
          className: "text-muted-foreground",
          title: formatTimestamp(ms, { unit: "milliseconds" }),
          children: formatRelativeTime(ms, { unit: "milliseconds" })
        }
      );
    }
  }
];
var DELIVERY_LABELS = {
  ok: "Sent",
  pending: "Sending",
  // Not "Error": nothing crashed. The destination is gone, disabled, or has no
  // channel wired — a configuration fact the reader can act on.
  failed: "Not sent",
  unknown: "Unconfirmed"
};
function txLinkColumn(render) {
  const base = COLUMNS.find((column) => column.id === "tx_hash");
  return {
    ...base,
    cell: ({ row }) => {
      const hash = alertTxHash(row.original);
      if (!hash) return /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "\u2014" });
      return render(hash, row.original);
    }
  };
}
function groupColumn(render) {
  return {
    id: "group",
    accessorFn: (event) => alertGroupId(event),
    size: 112,
    header: "Group",
    enableSorting: false,
    cell: ({ row }) => {
      const groupId = alertGroupId(row.original);
      if (!groupId) return /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "\u2014" });
      return render(groupId, row.original);
    }
  };
}
function acknowledgedColumn(controller) {
  return {
    id: "acknowledged",
    size: 140,
    // Sorts and searches on the actor, so "what is still unclaimed" is one
    // click and "what did I take" is one search.
    accessorFn: (event) => alertAcknowledgedBy(event),
    header: ({ column }) => /* @__PURE__ */ jsx(DataTableColumnHeader, { column, title: "Acknowledged" }),
    cell: ({ row }) => {
      const event = row.original;
      if (isAlertAcknowledged(event)) {
        const by = alertAcknowledgedBy(event);
        const at = alertAcknowledgedAtMs(event);
        return /* @__PURE__ */ jsx(
          "span",
          {
            className: "text-xs text-muted-foreground",
            title: at === null ? by || "Acknowledged" : `${by || "Acknowledged"} \xB7 ${formatTimestamp(at, { unit: "milliseconds" })}`,
            children: by || "Acknowledged"
          }
        );
      }
      const id = event.id;
      if (!id) return /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: "\u2014" });
      const pending = controller.acknowledging.has(id);
      return /* @__PURE__ */ jsx(
        Button,
        {
          variant: "outline",
          size: "sm",
          className: "h-7 text-xs",
          disabled: pending,
          onClick: () => {
            void controller.acknowledge(id).catch((error) => {
              notifyError(error, { title: "Couldn't acknowledge alert" });
            });
          },
          children: pending ? "Acknowledging\u2026" : "Acknowledge"
        }
      );
    }
  };
}
function findingsColumn(render) {
  return {
    id: "findings",
    header: "Findings",
    minSize: 90,
    enableSorting: false,
    // Not searchable, and no `accessorFn`: what the host renders is resolved
    // after the row is, so a filter over it would match whatever had arrived
    // when the caller typed.
    cell: ({ row }) => render(row.original)
  };
}
var COLUMN_LABELS = {
  severity: "Severity",
  rule: "Rule",
  tx_hash: "Transaction",
  group: "Group",
  findings: "Findings",
  chain_id: "Chain",
  when: "When",
  acknowledged: "Acknowledged"
};
function emptyCopy(hasMore) {
  if (hasMore) {
    return {
      emptyTitle: "Nothing on this page",
      emptyDescription: "There are older entries to read \u2014 load them to see whether this rule has fired."
    };
  }
  return {
    emptyTitle: "No alerts yet",
    emptyDescription: "Matched trigger events will appear here."
  };
}
function AlertHistoryTable({
  controller,
  height = "h-[480px]",
  className,
  emptyDescription,
  renderGroupLink,
  renderFindings,
  renderTxLink
}) {
  const { events, status, error, hasMore, loadMore, refresh } = controller;
  const columns = React3.useMemo(() => {
    const extra = [
      renderGroupLink ? groupColumn(renderGroupLink) : null,
      renderFindings ? findingsColumn(renderFindings) : null
    ].filter(Boolean);
    const tail = controller.canAcknowledge ? [acknowledgedColumn(controller)] : [];
    const base = renderTxLink ? COLUMNS.map((column) => column.id === "tx_hash" ? txLinkColumn(renderTxLink) : column) : COLUMNS;
    if (extra.length === 0) return [...base, ...tail];
    const at = base.findIndex((column) => column.id === "tx_hash") + 1;
    return [...base.slice(0, at), ...extra, ...base.slice(at), ...tail];
  }, [renderGroupLink, renderFindings, renderTxLink, controller]);
  return /* @__PURE__ */ jsxs("div", { className, children: [
    /* @__PURE__ */ jsx(
      ResourceTable,
      {
        rows: events,
        columns,
        getRowId: (event) => event.id,
        isLoading: status === "loading" && events.length === 0,
        isFetching: status === "loading",
        error: status === "error" ? error : void 0,
        onRetry: refresh,
        toolbar: {
          searchColumns: controller.canAcknowledge ? ["rule", "tx_hash", "chain_id", "acknowledged"] : ["rule", "tx_hash", "chain_id"],
          searchPlaceholder: "Search by rule, transaction or chain\u2026",
          columnLabels: COLUMN_LABELS
        },
        initialSorting: [{ id: "when", desc: true }],
        viewKey: "alerts.history",
        height,
        ...emptyCopy(hasMore),
        ...!hasMore && emptyDescription ? { emptyDescription } : {}
      }
    ),
    hasMore && /* @__PURE__ */ jsx("div", { className: "border-t p-2 text-center", children: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: loadMore, disabled: status === "loading", children: status === "loading" ? "Loading\u2026" : "Load older" }) })
  ] });
}

export { ALERTS_HISTORY_PAGE_SIZE, ALERTS_PACKAGE, ALERTS_PREVIEW_DEBOUNCE_MS, ALERTS_PREVIEW_LIMIT, ALERTS_RULE_EDITOR_HEIGHT, ALERT_AUTHORABLE_CHANNELS, ALERT_CHANNELS, ALERT_CHANNEL_LABELS, AlertHistoryTable, DestinationEditor, DestinationList, NoiseControls, RulePreview, SAMPLE_ENVELOPES, SEVERITY_TO_WIRE, TriggerRuleEditor, alertAcknowledgedAtMs, alertAcknowledgedBy, alertCriticality, alertDelivery, alertDeliveryOutcome, alertDispatchedTo, alertExpiresAtMs, alertGroupId, alertRuleFromTriggerRule, alertRuleToTriggerRule, alertSupersededAtMs, alertSupersededBy, alertTimestampMs, alertTxHash, constrainAlertRule, createApiAlertsSource, createInMemoryAlertsSource, defaultConfigFor, destinationTarget, emptyAlertRule, emptyCopy, emptyDestination, evaluateAlertRule, isAlertAcknowledged, isAlertSuperseded, newId, previewAlertRule, severityToWire, useAlertDestinations, useAlertHistory, useAlertRules };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map